import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'
import DocAbstract from './DocAbstract.js'

class Strategy extends DocAbstract.Strategy {
  getTypeCode () {
    return 'TEMPORARY_ID_RF'
  }
  getTypeName () {
    return 'Временное удостоверение личности РФ'
  }
  createModel () {
    var model = new Model()
    return model
  }
  createDefaultModel (individual) {
    return Object.assign(this.createModel(),
      {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        birthday: individual.birthday
      })
  }
  updateSteps (scheme) {
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymic',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs8: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthday',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplace',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Адрес места жительства(места пребывания)',
            name: 'address',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата выдачи',
            name: 'issued',
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Наименование подразделения',
            name: 'issuer',
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Причина выдачи',
            name: 'cause',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Действительно до',
            name: 'validTo',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Продлено до',
            name: 'extendedTo',
            grow: true,
            size: {sm6: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return '-'
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    return formats.createComp(`
      <div>
      <div>Дата выдачи:<b> ${model['issued'] ? formats.formatDate(model['issued']) : '-'}</b></div>
      <div>Действительно до:<b> ${model['validTo'] ? formats.formatDate(model['validTo']) : '-'}</b></div>
      <div>Продлено до:<b> ${model['extendedTo'] ? formats.formatDate(model['extendedTo']) : '-'}</b></div>
      </div>`)
  }
}

class Model {
  constructor () {
    this.modelType = '14.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/DocTemporaryIdRF.js